import React, { FC, useState, useEffect } from 'react'
// import cheerio from 'cheerio'
import { FiChevronRight } from 'react-icons/fi'
import { Collapse } from '@mui/material'
import get from 'lodash/get'
import { ProductByHandleQuery } from '../../../types/storefront'

// {
// INNER: String
// MODEL_WEARS?: String
// HEIGHT?: String
// BUST?: String
// WAIST?: String
// HIPS?:String
// }

interface Props {
  data: ProductByHandleQuery['product']
}
// tie-dye-long-casual-sweatshirt

const ProductSelect: FC<Props> = ({ data }) => {
  const [openStatus, setOpenStatus] = useState<boolean>(false)
  const [modelData, setModelData] = useState<any>({})
  const [collapsible, setCollapsible] = useState<any[][]>([])
  const [sizeGuideIndex, setSizeGuideIndex] = useState<number>(0)
  const [tabData, setTabData] = useState<any>([])
  // const tableData: any[] = [] //
  async function initialData() {
    if (!data) {
      return
    }
    const cheerio = (await import('cheerio')).default
    const $: any = cheerio.load(get(data, 'descriptionHtml'))
    const MODEL_DOM = $('.product-intro__sizeguide-summary-list')
    if (MODEL_DOM && MODEL_DOM?.length > 0) {
      const MODEL_WEARS = $('.product-intro__sizeguide-summary-list').find(
        'div > span'
      )[0].children[0].data
      const INNER = $('.inner img')[0].attribs.src || ''
      const [HEIGHT, BUST, WAIST, HIPS] = Array.from(
        $('.model-item > div > span')
      ).map((item: any) => item.children[0].data)
      /** 设置模特数据 */
      setModelData({
        INNER,
        MODEL_WEARS,
        HEIGHT,
        BUST,
        WAIST,
        HIPS,
      })
    } else {
      setModelData(null)
    }
    const collapsibles = Array.from($('.collapsible-content__inner > p')).map(
      (item: any) => item.children[0]?.data.split(':')
    )
    const SIMPLE_SIZEGUIDE_DOM = $('.tableList')
    if (SIMPLE_SIZEGUIDE_DOM && SIMPLE_SIZEGUIDE_DOM.length > 0) {
      const TAB_DATA_ITEM = SIMPLE_SIZEGUIDE_DOM.find('.table')
      const TAB_DATA_ITILE = $('.tab .tabSpan')
      // console.log('TAB_DATA_ITILE.TAB_DATA_ITILE', TAB_DATA_ITILE)
      const result: any[] = []
      for (let i = 0; i < TAB_DATA_ITEM.length; i += 1) {
        // console.log('index', TAB_DATA_ITEM.eq(i).html())
        result.push({
          name: TAB_DATA_ITILE.eq(i).text(),
          data: TAB_DATA_ITEM.eq(i).find('>div').html(),
        })
      }
      // console.log('item....', result)
      setTabData(result)
    }
    // console.log('折叠数据', collapsibles)
    setCollapsible(collapsibles)
  }
  useEffect(() => {
    initialData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  return (
    <>
      {modelData && modelData.INNER ? (
        <div className="model-wrapper pt-4 mx-3 border-b md:border-none">
          <h2 className="text-black text-sm font-semibold md:text-15">
            Model&apos;s Measurements
          </h2>
          <div className="flex w-full my-2.5">
            <div
              className="w-16 h-16 overflow-hidden relative bg-cover rounded-full"
              style={{ backgroundImage: `url(${modelData?.INNER})` }}
            />
            <div className="ml-4 flex flex-1 flex-col text-xs md:text-sm">
              <div className="flex flex-1">
                <div className="flex flex-1 items-center whitespace-nowrap">
                  Model Wears:{' '}
                  <span className="text-gray-400 ml-1">
                    {modelData.MODEL_WEARS}
                  </span>
                </div>
                <div className="flex flex-1 items-center ml-1" />
              </div>
              <div className="flex flex-1">
                <div className="text-xs flex flex-1 items-center whitespace-nowrap">
                  Height:
                  <span className="text-gray-400 ml-1">{modelData.HEIGHT}</span>
                </div>
                <div className="flex flex-1 items-center whitespace-nowrap">
                  Bust:
                  <span className=" text-gray-400 ml-1">{modelData.BUST}</span>
                </div>
              </div>
              <div className="flex flex-1">
                <div className="flex flex-1 items-center whitespace-nowrap">
                  Waist:
                  <span className="text-gray-400 ml-1">{modelData.WAIST}</span>
                </div>
                <div className="flex flex-1 items-center whitespace-nowrap">
                  Hips:
                  <span className="text-gray-400 ml-1">{modelData.HIPS}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="md:mt-3" />
      )}
      {tabData && tabData.length > 0 && (
        <div className="tab-wrapper mt-3 ml-3">
          <div className="tab-item">
            {tabData.map((i: any, idx: number) => (
              <span
                className={`cursor-pointer inline-flex h-7 px-4 items-center justify-center text-xs font-semibold border-2 border-black mr-3 ${
                  sizeGuideIndex === idx ? 'bg-black text-white h-8' : ''
                }`}
                key={i?.name}
                onClick={() => setSizeGuideIndex(idx as number)}
              >
                {i?.name}
              </span>
            ))}
          </div>
          <div className="table-item">
            <div className="overflow-x-auto nobar">
              <div
                className="text-xs md:text-sm mt-1.5 md:mb-2.5 leading-normal"
                dangerouslySetInnerHTML={{
                  __html: tabData[sizeGuideIndex]?.data,
                }}
              />
            </div>
          </div>
        </div>
      )}
      {collapsible && (
        <div className="details-wrapper md:border-1 md:border-black md:mb-3.5 ">
          <div
            className="flex justify-between mx-2.5 h-11 sm:border-t items-center md:justify-center relative cursor-pointer border-tag-graye9"
            onClick={() => {
              setOpenStatus(!openStatus)
            }}
          >
            <h2 className="text-black text-sm font-medium md:font-montserrat md:font-normal">
              Details
            </h2>
            <span
              className={`transform md:color-black absolute right-0 md:text-lg ${
                openStatus ? 'rotate-90' : 'rotate-225'
              }`}
            >
              <FiChevronRight size={16} color="#999999" />
            </span>
          </div>
          <Collapse in={openStatus}>
            <div className="mx-2.5">
              {collapsible.map(
                (i: any, idx: any) =>
                  i && (
                    <div
                      className="text-xs leading-1 pb-4 z-10 text-gray-500"
                      key={idx}
                    >
                      {i.join(': ')}
                    </div>
                  )
              )}
            </div>
          </Collapse>
        </div>
      )}
    </>
  )
}

export default ProductSelect
